import { n as a } from "./property-4FoNj0Pi.js";
function c(t) {
  return t != null && typeof t == "object" && t["@@functional/placeholder"] === !0;
}
function l(t) {
  return function e(r) {
    return arguments.length === 0 || c(r) ? e : t.apply(this, arguments);
  };
}
function d(t) {
  return function e(r, u) {
    switch (arguments.length) {
      case 0:
        return e;
      case 1:
        return c(r) ? e : l(function(n) {
          return t(r, n);
        });
      default:
        return c(r) && c(u) ? e : c(r) ? l(function(n) {
          return t(n, u);
        }) : c(u) ? l(function(n) {
          return t(r, n);
        }) : t(r, u);
    }
  };
}
var h = /* @__PURE__ */ d(function(e, r) {
  for (var u = {}, n = {}, i = 0, s = e.length; i < s; )
    n[e[i]] = 1, i += 1;
  for (var f in r)
    n.hasOwnProperty(f) || (u[f] = r[f]);
  return u;
});
function g(t) {
  return function(e, r) {
    if (!t || t.default === void 0) {
      a(t)(e, r);
      return;
    }
    const u = (i) => t.default instanceof Function && t.type !== Function ? t.default(i) : t.default, n = `__${r}`;
    a({
      attribute: r,
      ...h(["default"], t)
    })(e, r), Object.defineProperty(e, r, {
      set(i) {
        this[n] = i === void 0 ? u(this) : i, this.requestUpdate(r);
      },
      get() {
        return this[n] === void 0 ? u(this) : this[n];
      }
    });
  };
}
export {
  d as _,
  l as a,
  g as p
};
